<template>
  <div class="pfslide" style="margin-bottom: 5px">
    <div class="pfslide__title  pfslide__title_smspace" v-html="title"></div>
    <div class="pfslide__smtitle">На Ваши данные мы&nbsp;отправим&nbsp;полис</div>
    <div class="pfslide__thincontent">
      <NumberInput text='Номер телефона'
                name='tel'
                type='tel'
                :filled="(v)=>v.length==18"
                mask='+7 (###) ###-##-##'
                v-model="client.tel" />
      <EmailInput text='E-mail'
                name='email'
                v-model="client.email" />
    </div>
  </div>
</template>

<script>
  import slide from '../../mixins/slide.vue'
import NumberInput from '../inputs/NumberInput.vue';
import EmailInput from '../inputs/EmailInput.vue';
  export default {
    name: "slide4",
    mixins: [slide],
    components: { NumberInput, EmailInput }
}
</script>

<style lang="sass" scoped>

</style>